export default __webpack_public_path__ + "static/fsk_case_webm-ad51eb2f3500ce602cc8484ee9f3f9b4.webm";